import React, { Component } from 'react';
import './index.css';

class CustomButton extends Component {

  constructor(props) {
    super(props);
    this.state = { }
    this.clickHandler = this.clickHandler.bind(this);
    this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
  }


  clickHandler(e) {
    if(this.props.onClick && typeof this.props.onClick === 'function'){
      this.props.onClick()
    }
  }

  mouseEnterHandler(e) {
    if(this.props.onMouseEnter && typeof this.props.onMouseEnter === 'function'){
      this.props.onMouseEnter()
    }
  }

  mouseLeaveHandler(e) {
    if(this.props.onMouseLeave && typeof this.props.onMouseLeave === 'function'){
      this.props.onMouseLeave()
    }
  }



  render() {
    const { style, children, className } = this.props;
    return (
      <button
        style={style}
        onClick={this.clickHandler}
        onMouseEnter={this.mouseEnterHandler}
        onMouseLeave={this.mouseLeaveHandler}
        className={className + ' custom-button'}
      >
        <div>{children}</div>
      </button>
    );
  }
}


export default CustomButton;
